import { axiosErrorMessage } from "@hubrise/react-components"
import { isAxiosError } from "axios"
import * as React from "react"

import Layout from "shared/components/Layout"
import { ErrorPage, ErrorPageInner, ErrorBox, Title } from "shared/components/PageError/Styles"

interface PageErrorProps {
  error?: unknown
}

const PageError = ({ error }: PageErrorProps): JSX.Element => (
  <Layout>
    <ErrorPage>
      <ErrorPageInner>
        <ErrorBox>
          <Title>There&apos;s been a glitch...</Title>
          <p>{isAxiosError(error) ? axiosErrorMessage(error) : "We're not quite sure what went wrong."}</p>
          <p>Please click on the logo to go back to the home page.</p>
        </ErrorBox>
      </ErrorPageInner>
    </ErrorPage>
  </Layout>
)

export default PageError
